import {Component, OnInit} from '@angular/core';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import { MatStepper, MatStep, MatStepLabel, MatStepperIcon } from '@angular/material/stepper';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'tw-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.css'],
    providers: [{
            provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
        }],
    imports: [MatStepper, MatStep, MatStepLabel, MatStepperIcon, MatIcon]
})
export class StepperComponent implements OnInit {
    home ='home';
    Cart ='Cart';
    Profile= 'Profile';
    Checkout = 'Checkout';
    done = 'done';
    constructor() {
    }

    ngOnInit() {
    }

    getInde($event: any) {
        //console.log($event);
    }
}
